import { find, findAll } from "../utils/dom";
import Swiper from "swiper";
import animationAccordion from "../animation/animationAccordion"
import animationCustomHome from "../animation/animationCustomHome"
import animationCustomProdutos from "../animation/animationCustomProdutos"
import { pushDL, pushEcommerceDL, produtoItemId, listaProdutosId } from "../utils/datalayer.js";

const PageInspiracao = () => {
    const page = find("[js-page='inspiracoes']");
    if (!page) return;

    // Filtro de receitas por tipo de produto: mesmo view_item_list da página de produtos
    const dadosLista = document.getElementById('dl-lista-produtos');
    if (dadosLista) {
        const lista = JSON.parse(dadosLista.textContent);
        pushEcommerceDL('view_item_list', {
            item_list_id: listaProdutosId(lista.nome),
            item_list_name: lista.nome,
            items: lista.items.map(function (produto, index) {
                return {
                    item_id: produtoItemId(produto.id),
                    item_name: produto.nome,
                    item_brand: 'Matinal',
                    item_category: lista.nome,
                    item_variant: produto.variante || '',
                    index: index + 1
                };
            })
        });
    }

    document.addEventListener('click', function (e) {
        const card = e.target.closest('.receita-card');
        if (!card || !page.contains(card)) return;
        // O card inteiro é o link e não tem botão visível, então o texto do CTA é fixo
        pushDL('select_recipe', {
            button_text: 'Ler mais',
            recipe_name: card.dataset.recipeName
        });
    });

    function bt_filtro() {
        const BTFiltro = find('[js-filtro-butao]');
        const FiltroContent = find('[js-filtro-content]');

        if (!BTFiltro) return;

        BTFiltro?.addEventListener("click", () => {
            FiltroContent.classList.toggle('filtro_active');
        })
    }


    function bt_tags() {
        const buttons = findAll('.swiper-button-disabled');
        if (!buttons) return;

        if (buttons.length == 2) {
            find('.swiper-inspiracao-controlls').style.display = "none";
        }
    }


    const swiperinspiracao = new Swiper(".swiper-inspiracao", {
        mousewheel: false,
        slidesPerView: "auto",
        spaceBetween: 20,
        pagination: {
            el: ".swiper-inspiracao-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-inspiracao-next",
            prevEl: ".swiper-inspiracao-prev",
        },
        breakpoints: {
            767: {
                spaceBetween: 80,
            }
        }
        // thumbs: {
        // 	swiper: swiperVerticalTimeline,
        //   },

    })

    animationAccordion();
    animationCustomProdutos();
    bt_tags();
    bt_filtro();
}

export default PageInspiracao;